<div class="page admin js-page" style="transition: .2s;">
  <app-side-nav class="hidden-print sidenav" (onComponentSelected)="select($event)">
  </app-side-nav>

  <div class="adminpanel" [ngSwitch]="selected">
    <div *ngSwitchCase="'admin_objects'" class="resizetable adminobjects" app-objects></div>
    <ng-container *ngSwitchCase="'admin_users'">
      <div *ngIf="usersService.InterfaceIsPermitted(InterfacePermissions.USERS)" class="resizetable adminusers"
        app-users>
      </div>
    </ng-container>
    <div *ngSwitchCase="'admin_drivers'" class="resizetable admindrivers" app-drivers></div>

    <div *ngSwitchCase="'admin_tasks'" class="resizetable admintasks" app-tasks></div>

    <div *ngSwitchCase="'admin_shifts'" class="resizetable adminshifts" app-shifts></div>

    <div *ngSwitchCase="'admin_routes'" class="resizetable adminroutes" app-routes></div>

    <div *ngSwitchCase="'admin_keys'" class="resizetable adminkeys" app-keys></div>

    <div *ngSwitchCase="'admin_commands'" class="resizetable admincommands" app-commands-component></div>

    <div *ngSwitchCase="'admin_companies'" class="resizetable admincompanies" app-companies></div>

    <div *ngSwitchCase="'admin_zones'" class="resizetable admingeozona" app-geozone></div>

    <div *ngSwitchCase="'admin_notifications'" class="resizetable adminnotifications" app-notifications></div>

    <div *ngSwitchCase="'admin_server'" class="resizetable adminserver" app-server-admin></div>

    <div *ngSwitchCase="'admin_reports'" class="resizetable adminreports" app-report-templates></div>

    <div *ngSwitchCase="'retranslations'" class="resizetable retranslations" app-retranslators></div>

    <div *ngSwitchCase="'admin_object_groups'" class="resizetable adminobjectgroups" app-object-groups-admin></div>
  </div>
</div>
